export const Cameras_listing = (t: any, link: any, i18n) => [
  {
    Header: t("Farm Code"),
    accessor: "farm_code",
  },

  {
    Header: t("Field Code"),
    accessor: "field_code",
  },
  {
    Header: t("CameraCode"),
    accessor: "camera_code",
  },
  /*  {
    Header: t("Location"),
    accessor: "location",
  }, */
  {
    Header: t("CameraDescription"),
    accessor: "description",
  },

  {
    Header: t("Manufacturer"),
    accessor:
      i18n.language === "en" ? "camera_ownership" : "camera_ownership_ar",
  },
  {
    Header: t("Model"),
    accessor: "camera_model",
  },

  {
    Header: t("IP"),
    accessor: "camera_ip",
  },

  {
    Header: t("Accesslink"),
    accessor: "access_link",
    Cell: ({ cell: { value } }) => {
      return link(value);
    },
  },
];
